import { useStaticQuery, graphql } from 'gatsby';

export const useOpenHoursConfiguration = () => {
  const { openHours } = useStaticQuery(graphql`
    query OpenHoursQuery {
      openHours: allStoryblokEntry(
        filter: { field_component: { eq: "configuration_open_hours" } }
      ) {
        edges {
          node {
            field_phone_number_string
            field_open_hours_wednesday_string
            field_open_hours_tuesday_string
            field_open_hours_thursday_string
            field_open_hours_sunday_string
            field_open_hours_saturday_string
            field_open_hours_monday_string
            field_open_hours_friday_string
            lang
          }
        }
      }
    }
  `);

  const res = openHours.edges.find(
    (n) => n.node.lang === process.env.GATSBY_STORYBLOK_LANGUAGE,
  );
  return res.node;
  /*graphql`
      query OpenHoursQuery {
        openHours: storyblokEntry(
          field_component: { eq: "configuration_open_hours" }
        ) {
          field_phone_number_string
          field_open_hours_monday_string
          field_open_hours_tuesday_string
          field_open_hours_wednesday_string
          field_open_hours_thursday_string
          field_open_hours_friday_string
          field_open_hours_saturday_string
          field_open_hours_sunday_string
        }
      }
    `,*/
};
